export enum CommonColumn {
  Select = 'select',
  Favorite = 'favorite',
  DataQualityIndicator = 'dataqualityindicator',
  Certification = 'certification',
  ContentType = 'contentype',
  Name = 'name',
  OriginalViewName = 'originalviewname',
  ActionsMenu = 'actionsmenu',
  ActionsMenuForCatalog = 'actionsmenuForCatalog',
  ProjectsCount = 'projectscount',
  WorkbooksCount = 'workbookscount',
  Hits = 'hitsCol',
  ViewsCount = 'viewscount',
  SheetsCount = 'sheetscount',
  SheetsCountInCrass = 'sheetscountcrass',
  Workbook = 'workbook',
  DatasourcesCount = 'datasourcescount',
  Size = 'size',
  SheetNumber = 'sheetnumber',
  DatasourceInWorkbooksCount = 'datasourceinworkbookscount',
  ConnectsTo = 'connectsto',
  Location = 'location',
  Owner = 'owner',
  OwnerWithIcon = 'ownerWithIcon',
  Created = 'created',
  CreatedTime = 'createdTime',
  Modified = 'modified',
  UpdatedTime = 'updatedTime',
  ModifiedBy = 'modifiedBy',
  ExtractStatus = 'extractstatus',
  ExtractStatusOnly = 'extractstatusonly',
  Alert = 'alert',
  ConnectionType = 'connectiontype',
  Authentication = 'authentication',
  Username = 'username',
  Datasource = 'datasource',
  RunNextAt = 'nextUpdate',
  Status = 'status',
  Priority = 'priority',
  TaskType = 'taskType',
  DataType = 'dataType',

  // Subscriptions
  Subject = 'subject',
  UsernameForSubscription = 'usernameForSubscription',
  SubscribedTo = 'subscribedTo',
  Schedule = 'schedule',
  SubscribedBy = 'subscribedBy',
  LastUpdate = 'lastUpdate',
  LastRunAt = 'lastRunAt',
  RunNextAtSubscription = 'nextUpdate',

  // Extract tasks
  TargetType = 'targetType',
  ExtractTaskName = 'extractTaskName',
  WorkbookDatasourceName = 'workbookDatasourceName',
  RemoteRefreshType = 'remoteRefreshType',
  Definition = 'definition',
  RemoteRefreshPriority = 'remoteRefreshPriority',
  State = 'state',
  LastRunAtExtractRefreshes = 'LastRunAtExtractRefreshes',
  LastRefreshedAt = 'lastRefreshedAt',

  // Linked tasks
  LinkedTaskWithCount = 'linkedTaskWithCount',

  // recents
  LastAccessedAt = 'lastAccessedAt',

  // Flows
  FlowName = 'flowName',
  OutputStep = 'outputStep',
  OutputSteps = 'outputSteps',
  OutputStepsWithLinkedTasks = 'OutputStepsWithLinkedTasks',
  RunType = 'runType',
  RunStartedAt = 'runStartedAt',
  RunEndedAt = 'runEndedAt',
  RunDuration = 'runDuration',
  RunStatus = 'runStatus',
  RunRowsProduced = 'runRowsProduced',
  RunErrors = 'runErrors',
  RunFlowTasksStatus = 'runFlowTasksStatus',
  LastRunAtFlows = 'lastRunAtFlows',
  RunNextAtFlows = 'runNextAtFlows',
  FlowFileType = 'fileType',
  FlowScheduleType = 'flowScheduleType',
  FlowOrLinkedTask = 'flowOrLinkedTask',
  FlowParameterWithOverride = 'flowParameterWithOverride',
  FlowParameterRunWithOverride = 'flowParameterRunWithOverride',

  // Jobs
  Id = 'id',
  BackgroundJobType = 'BackgroundJobType',
  BackgroundJobPriority = 'BackgroundJobPriority',
  ContentOwner = 'contentOwner',
  JobRequestedTime = 'jobRequestedTime',
  CurrentRunTime = 'currentRunTime',
  CurrentQueueTime = 'currentQueueTime',
  AverageRunTime = 'averageRunTime',
  AverageQueueTime = 'averageQueueTime',

  //Metrics
  MetricValue = 'metricValue',
  MetricConnectedView = 'metricConnectedView',
  MetricUpdated = 'metricUpdated',

  // Data Alerts
  DataAlertSubject = 'dataAlertSubject',
  DataAlertView = 'dataAlertView',
  DataAlertRecepient = 'dataAlertRecepient',
  DataAlertVisibleTo = 'dataAlertVisibleTo',
  DataAlertFrequency = 'dataAlertFrequency',
  DataAlertLastCheck = 'dataAlertLastCheck',
  DataAlertLast = 'dataAlertLast',

  // Site
  SiteNameLink = 'linkSiteName',
  SiteUserCount = 'siteUserCount',
  SiteAdminCount = 'siteAdminCount',
  SiteUserQuota = 'siteUserQuota',
  SiteStorageUsed = 'siteStorageUsed',
  SiteStorageQuota = 'siteStorageQuota',
  SiteStatus = 'siteStatus',
  SiteMetricsEnabled = 'siteMetricsEnabled',
  SiteAuthoringEnabled = 'siteAuthoringEnabled',
  SiteSheetImageEnabled = 'siteSheetImageEnabled',
  SiteEditMembership = 'siteEditMembership',
  SiteExtractEncryption = 'siteExtractEncryption',
  SiteGuestAccessEnabled = 'siteGuestAccessEnabled',
  SiteAskDataMode = 'siteAskDataMode',

  // Schedules
  ScheduleName = 'scheduleName',
  ScheduleFrequency = 'scheduleFrequency',
  ScheduleTaskType = 'scheduleTaskType',
  ScheduleTasks = 'scheduleTasks',
  ScheduleExecution = 'scheduleExecution',
  ScheduleNextRunAt = 'scheduleNextRunAt',
  ScheduleLinkedTask = 'scheduleLinkedTask',
  SiteName = 'siteName',

  // Groups
  GroupName = 'groupName',
  GroupDomain = 'groupDomain',
  GroupUserCount = 'groupUserCount',
  GroupMinSiteRole = 'groupMinSiteRole',
  GroupLicenseOnSignIn = 'groupLicenseOnSignin',

  // Site Users
  SiteUserName = 'siteUserName',
  SiteUserRole = 'siteUserRole',
  SiteUserLastSignin = 'siteUserLastSignin',
  SiteUserDomainName = 'siteUserDomainName',
  SiteUserAuthentication = 'siteUserAuthentication',
  SiteUserDisplayName = 'siteUserDisplayName',

  // Server Users
  ServerUserDisplayName = 'serverUserDisplayName',
  ServerUserMaxSiteRole = 'serverUserMaxSiteRole',
  ServerUserLicenseLevel = 'serverUserLicenseLevel',
  ServerUserSiteCounts = 'serverUserSiteCounts',

  // Identities
  IdentityConflictFailureType = 'failureType',

  // Search Users (only used in search)
  SearchUserOwnedViewsCount = 'searchUserOwnedViewsCount',
  SearchUserOwnedWorkbooksCount = 'searchUserOwnedWorkbooksCount',
  SearchUserOwnedDatasourcesCount = 'searchUserOwnedDatasourcesCount',

  // Collections
  CollectionName = 'collectionName',
  CollectionItemCount = 'collectionItemCount',
  CollectionVisibility = 'collectionVisibility',

  // Shared With Me
  SharedBy = 'sharedBy',
  SharedCustomizedView = 'sharedCustomizedView',
  SharedAt = 'sharedAt',
  SharedWith = 'sharedWith',
  NameWithAccessStatus = 'nameWithAccessStatus',

  // Drafts
  NameWithMarkers = 'nameWithMarkers',

  // Data Acceleration
  SpeedUp = 'speedUp',
  AvgNonAcceleratedPLT = 'avgNonAcceleratedPLT',
  AvgAcceleratedPLT = 'avgAcceleratedPLT',
  IsAccelerated = 'isAccelerated',
  OptimizationNotes = 'optimizationNotes',
  Acceleration = 'acceleration',
  AccelerationTaskName = 'accelerationTaskName',
  LastMonthViewCount = 'lastMonthViewCount',
  avgLoadTimeWithMaterialization = 'avgLoadTimeWithMaterialization',
  avgLoadTimeWithoutMaterialization = 'avgLoadTimeWithoutMaterialization',
  LastMonthJobCount = 'lastMonthJobCount',
  lastMonthJobAvgTimeInSec = 'lastMonthAvgJobTimeInSec',
  EstimatedDiskUsageKb = 'estimatedDiskUsageKb',
  DataAccelerationStatus = 'dataAccelerationStatus',

  // CRASS
  ConnectionTypeInCrass = 'connectionTypeCrass',
  Contact = 'contact',
  ServerOrPath = 'serverOrPath',
  DownstreamDataSourcesCount = 'downstreamDataSourcesCount',
  DownstreamWorkbookCount = 'downstreamWorkbookCount',
  TypeForCrass = 'typeForCrass',
  DataQualityWarning = 'dataQualityWarning',
  TableDatabase = 'database',
  TableColumns = 'columns',

  // ConnectedApplications
  ConnectedApplicationStatus = 'connectedApplicationStatus',
  ConnectedApplicationDomains = 'domains',
  ConnectedApplicationClientId = 'clientId',
  ConnectedApplicationScope = 'scope',

  // PublishedConnection
  PublishedConnection = 'virtualConnections',
  PublishedConnectionExtractStatus = 'virtualConnectionExtractStatus',
  PublishedConnectionPolicies = 'virtualConnectionPolicies',
  PublishedConnectionTableName = 'virtualConnectionTableName',

  // Resource Governance
  ResourceGovernanceSite = 'resourceGovernanceSite',
  ResourceGovernanceConfiguration = 'resourceGovernanceConfiguration',
  ResourceGovernanceExtracts = 'resourceGovernanceExtracts',
  ResourceGovernanceSubscriptions = 'resourceGovernanceSubscriptions',
  ResourceGovernanceFlows = 'resourceGovernanceFlows',
  ResourceGovernanceRuntimeLimits = 'resourceGovernanceRuntimeLimits',
  ResourceGovernanceActualRuntime = 'resourceGovernanceActualRuntime',
  ResourceGovernanceJobs = 'resourceGovernanceJobs',
}
